import actions from '../../actionTypes';

export default (account, zoneId) => {
  return {
    type: actions.GET_LOCATIONS,
    account,
    zoneId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/getLocations.js